enum TopLevelSite {
    RU = 'hh.ru',
    UA = 'hh.ua',
    UZ = 'hh.uz',
    GE = 'headhunter.ge',
    KG = 'headhunter.kg',
    KZ = 'headhunter.com.kz',
    AZ = 'jobs.day.az',
    BY = 'jobs.tut.by',
    ZP = 'zarplata.ru',
}

export default TopLevelSite;
